<template>
  <div class="notfound" v-if="!isProcessing">
    <div class="notfound__item">
      <v-img class="notfound__item__img" :src="require('@/assets/akiyama/research-研究.png')" />
      <h1 class="notfound__item__title">404</h1>
      <p class="notfound__item__explain">
        アクセスされたページが見つかりません...<br>
        ホームへ戻って再度アクセスをお願いします。
      </p>
      <common-button class="notfound__item__button" text='ホームへ戻る' :is-active="true" @emit-event="$router.push({ name: 'top' })" />
    </div>
  </div>
</template>

<script>
import CommonButton from '@/components/common/button'

export default {
  components: { CommonButton },
  name: 'notfound',
  metaInfo () {
    const meta = this.$route.meta
    const path = this.$route && this.$route.path ? this.$route.path : window.location.pathname
    const isNoindex = !!(meta.noindex)
    return {
      title: meta.title,
      description: meta.description,
      meta: isNoindex ? [{ Name: 'robots', content: 'noindex' }] : [],
      link: [
        { rel: 'canonical', href: `${window.location.protocol}//${window.location.host}${path}` }
      ],
      og: {
        title: meta.title,
        description: meta.description
      }
    }
  },
  mounted () {
    // 処理中の解除
    this.$store.commit('setProcessing', false)
  },
  computed: {
    /**
     * @return {Boolean} 処理中かどうか
     */
    isProcessing () {
      return this.$store.getters.isProcessing
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/sass/color.scss';
@import '@/assets/sass/size.scss';

.notfound {
  position: relative;
  width: 100vw;
  height: 100vh;
  text-align: center;
  &__item {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 90%;
    transform: translateY(-50%) translateX(-50%);
    &__img {
      height: 100px;
      margin-bottom: $unit_size;
    }
    &__title {
      font-size: 3.2rem;
      line-height: 4.4rem;
      color: $red_normal_color;
    }
    &__explain {
      margin: $unit_size*3 0;
      font-size: 1.4rem;
      line-height: 1.9rem;
    }
  }
}
</style>
